import React from 'react';
import { useAuth } from 'react-oidc-context';
import { Button, Dropdown, Avatar, message, Typography } from 'antd';
import { UserOutlined, LogoutOutlined, CopyOutlined } from '@ant-design/icons';

const { Text } = Typography;

const UserInfo = () => {
    const auth = useAuth();

    if (!auth.isAuthenticated || !auth.user) {
        return null; // Hide component if not authenticated
    }

    // Use token data directly - no need for API call
    const tokenPayload = auth.user?.profile || {};
    const userName = tokenPayload.name || tokenPayload.preferred_username ||
        (tokenPayload.upn ? tokenPayload.upn.split('@')[0] : '') || 'User';
    const userEmail = tokenPayload.email || '';
    const tenantId = tokenPayload.tenant || tokenPayload.tenant_id || tokenPayload.tid || 'N/A';
    const tenantName = tokenPayload.tenant_name || 'N/A';

    const handleLogout = async () => {
        // Remove local user data and redirect to ICP for re-login
        await auth.removeUser();
        auth.signinRedirect();
    };

    const handleCopy = (text, label) => {
        navigator.clipboard.writeText(text).then(() => {
            message.success(`${label} copied to clipboard`);
        }).catch(() => {
            message.error('Failed to copy to clipboard');
        });
    };

    const menuItems = [
        {
            key: 'user-info',
            label: (
                <div style={{ padding: '4px 0' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                        <Text strong style={{ fontSize: '12px', color: '#666' }}>Tenant:</Text>
                        <Text style={{ fontSize: '12px' }}>{tenantName}</Text>
                        <Button
                            type="text"
                            size="small"
                            icon={<CopyOutlined />}
                            onClick={() => handleCopy(tenantName, 'Tenant name')}
                            style={{ padding: '0 4px', height: '16px', minWidth: '16px' }}
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                        <Text strong style={{ fontSize: '12px', color: '#666' }}>Tenant ID:</Text>
                        <Text style={{ fontSize: '12px', fontFamily: 'monospace' }}>{tenantId}</Text>
                        <Button
                            type="text"
                            size="small"
                            icon={<CopyOutlined />}
                            onClick={() => handleCopy(tenantId, 'Tenant ID')}
                            style={{ padding: '0 4px', height: '16px', minWidth: '16px' }}
                        />
                    </div>
                    {userEmail && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <Text strong style={{ fontSize: '12px', color: '#666' }}>Email:</Text>
                            <Text style={{ fontSize: '12px' }}>{userEmail}</Text>
                            <Button
                                type="text"
                                size="small"
                                icon={<CopyOutlined />}
                                onClick={() => handleCopy(userEmail, 'Email')}
                                style={{ padding: '0 4px', height: '16px', minWidth: '16px' }}
                            />
                        </div>
                    )}
                </div>
            ),
            disabled: true,
        },
        {
            type: 'divider',
        },
        {
            key: 'logout',
            label: 'Log out',
            icon: <LogoutOutlined />,
            onClick: handleLogout,
        },
    ];

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Dropdown
                menu={{
                    items: menuItems,
                    style: {
                        minWidth: '280px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                    }
                }}
                placement="bottomRight"
                trigger={['click']}
                overlayStyle={{
                    borderRadius: '8px',
                }}
            >
                <Button
                    type="text"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        height: 'auto',
                        padding: '6px 12px',
                        borderRadius: '6px',
                        transition: 'all 0.2s',
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#f5f5f5';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'transparent';
                    }}
                >
                    <Avatar icon={<UserOutlined />} size="small" style={{ backgroundColor: '#1890ff' }} />
                    <span style={{ fontWeight: 500 }}>{userName}</span>
                </Button>
            </Dropdown>
        </div>
    );
};

export default UserInfo;

